import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import AccountDetailsSectionMobile
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/AccountDetailsSectionMobile';
import AccountDetailsSection
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/AccountDetailsSection';


const AccountDetailsSectionPicker = () => {
  const isMobile = useMobileLayout();
  if (isMobile) {
    return <AccountDetailsSectionMobile />;
  }

  return <AccountDetailsSection />;
};

export default AccountDetailsSectionPicker;
